import styled, { css } from 'styled-components';
import { CLOSE_SIZE } from '@CS/components/Popups';

type LeaderboardContainerAttributes = {
  popup?: boolean;
};

export const LeaderboardContainer = styled.div(
  ({ popup }: LeaderboardContainerAttributes) => css`
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: none;
    justify-content: flex-start;
    padding: min(3.5vmax, 25px);

    background-color: white;
    flex-direction: column;
    align-content: center;
    overflow: hidden auto;

    align-items: center;
    position: relative;
    flex-wrap: nowrap;

    display: flex;
    height: auto;
    width: 100%;

    ${popup &&
    css`
      margin-top: calc(${CLOSE_SIZE} / -2);
      padding: 0;

      h2:first-child {
        max-width: 80%;
      }
    `}
  `
);

export const LeaderboardTitle = styled.h2`
  text-transform: uppercase;
  margin-bottom: 1rem;
  text-align: center;

  position: relative;
  display: block;
  color: black;

  height: auto;
  width: 100%;
`;

export const LeaderboardScores = styled.ul`
  position: relative;
  list-style: none;
  display: block;

  height: auto;
  width: 100%;

  padding: 0;
  margin: 0;
`;

const ROW_MARGIN = 10;
const LIST_WIDTH = 75;

type ScoreContainerAttributes = {
  user?: boolean;
};

export const ScoreContainer = styled.li(
  ({ user }: ScoreContainerAttributes) => css`
    margin-bottom: ${ROW_MARGIN}px;

    position: relative;
    overflow: hidden;
    width: 100%;

    &:nth-child(even) {
      background-color: rgb(240 240 240);
    }

    &:last-child {
      margin-bottom: 0;
    }

    ${user &&
    css`
      &:last-child {
        background-color: inherit;
      }
    `}
  `
);

export const UserSeparator = styled.hr`
  background-color: rgb(0 0 0);
  margin: ${ROW_MARGIN}px 0;
  position: relative;

  display: block;
  border: none;

  height: 2px;
  width: 100%;
`;

export const UserPosition = styled.pre`
  width: ${100 - LIST_WIDTH}%;
  color: rgb(127 127 127);
  display: inline-block;

  font-family: inherit;
  font-weight: 700;
  margin: 0;
`;

export const UserScoreList = styled.div`
  justify-content: space-between;
  width: ${LIST_WIDTH}%;
  align-content: center;
  display: inline-flex;

  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
`;

export const UserName = styled.span`
  color: rgb(0 0 0);
`;

export const UserScore = styled.em`
  color: rgb(34 34 34);
  font-style: normal;
  font-weight: 700;
`;

export const LeaderboardPage = styled.section`
  background-color: white;
  justify-content: center;
  flex-direction: column;
  align-content: center;

  align-items: center;
  min-height: 100vmax;
  position: relative;
  flex-wrap: nowrap;
  display: flex;
`;
